import {
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
  ViewMode,
  ORDER_REQUEST_STATUS,
  ORDER_CHANGE_SHOW_MY_ORDERS,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  mode: ViewMode.List,
  list: [],
  order: {},
  totalCount: 0,
  showOnlyMyOrders: false,
  availableStatusFilters: {},
  errors: {},
};

export const order = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ORDER_RECEIVE:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
    case ORDER_REQUEST_STATUS:
    case ORDER_CHANGE_SHOW_MY_ORDERS:
      return {
        ...state,
        errors: {},
        ...payload,
      };
    case ORDER_ERROR: {
      const { error: _, ...payloadWithoutError } = payload;
      return {
        ...state,
        errors: errorReducer(state.errors, action),
        ...payloadWithoutError,
      };
    }
    default:
      return state;
  }
};
